import { render, staticRenderFns } from "./PriceConfigTableHeader.vue?vue&type=template&id=796258f4&"
import script from "./PriceConfigTableHeader.vue?vue&type=script&lang=ts&"
export * from "./PriceConfigTableHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports